import {
  FILTER,
  SELECTED_CATEGORY,
} from '../actions/items'

import metadata from '../metadata'

const CATEGORIES = [  
  { key: 'dataSystems',  path: 'data-systems', label: 'Data Systems', enabled: true, roles: ['admin', 'power_user', 'user'] },
  { key: 'dataTypes',    path: 'data-types',   label: 'Data Types',   enabled: true, roles: ['admin', 'power_user', 'user'] },
  { key: 'dataSources',  path: 'data-sources', label: 'Data Sources', enabled: true, roles: ['admin', 'power_user', 'user'] },
  { key: 'integrations', path: 'integrations', label: 'Integrations', enabled: true, roles: ['admin', 'power_user', 'user'] },
  { key: 'endpoints',    path: 'endpoints',    label: 'Endpoints',    enabled: true, roles: ['admin', 'power_user', 'user'] },
  // { key: 'holds',        path: 'holds',        label: 'Holds',        enabled: true, roles: ['admin'] },
  { key: 'maintenance',          path: 'maintenance',                 label: 'Maintenance',                  enabled: true, roles: ['admin', 'power_user'] },
  { key: 'maintenanceTemplates', path: 'maintenance-templates',       label: 'Maintenance Templates',        enabled: true, roles: ['admin', 'power_user'] },
  { key: 'jobs',         path: 'jobs',         label: 'Jobs',         enabled: true, roles: ['admin', 'power_user', 'user'] },
  {
    key:     'logs',
    label:   'Logs',
    enabled: true,
    roles:   ['admin', 'power_user', 'user'],
    children: [
      { key: 'gatewaySchedulerLogs',     path: 'gateway-scheduler-logs',      label: 'Gateway Scheduler Logs',      enabled: true, roles: ['admin', 'power_user', 'user'] },
      { key: 'batchDeliveryManagerLogs', path: 'batch-delivery-manager-logs', label: 'Batch Delivery Manager Logs', enabled: true, roles: ['admin', 'power_user', 'user'], featureFlag: 'enableBatchDeliveries' },
    ]
  },
  { key: 'users', path: 'users', label: 'Users', enabled: true, utilities: true, featureFlag: 'roles', roles: ['admin'] },
]

const initialState = {
  categories:       CATEGORIES,
  selectedCategory: 'jobs',

  dataLoading:    false,
  data:           {},
  filterCriteria: {},
  filteredItems:  [],
}

function getFilteredItems(filterCriteria, data) {
  const unfiltered = data[filterCriteria.category] || []

  if (!metadata[filterCriteria.category]) {
    return unfiltered
  }

  const filterProps = metadata[filterCriteria.category].filterProperties

  return unfiltered.filter((item) => {
    return filterProps.find((filterProp) => {
      return item[filterProp]
        && item[filterProp].toLowerCase().indexOf(filterCriteria.filter.toLowerCase()) >= 0
    })
  })  
}

export default function products(state = initialState, action) {
  switch (action.type) {
    case SELECTED_CATEGORY:
      return { ...state, selectedCategory: action.value }

    case FILTER:
      const filterCriteria = action.value
      const filteredItems  = getFilteredItems(filterCriteria, state.data)

      return { ...state, filterCriteria, filteredItems }
    default:
      return state
  }
}